import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Parts/Button';
import { formatPrice } from '../../utils/string';
import s from './Cart.scss';

const Cart = ({ shop, productList, staticTexts, adjustItem, popup = false }) => {
	if (productList === undefined || productList.products === undefined || !productList.availability) return null;

	const cartClasses = [s.cart];
	if (popup) cartClasses.push(s.cart__popup);

	const adjustItemHandler = (e) => {
		e.preventDefault();
		const $a = e.currentTarget.closest('a');
		const id = $a.dataset.id;
		const method = $a.getAttribute('href').slice(1);
		adjustItem(id, method);
	};

	return (
		<div className={cartClasses.join(' ')}>
			<div className={s.cart_inner}>
				{
					!popup ? (
						<div className={s.cart_header}>
							<h2 className={s.cart_header_column}>{staticTexts.item}</h2>
							<h2 className={[s.cart_header_column, s.cart_header_column__mobileText].join(' ')} data-mobiletext={staticTexts.qty}>{staticTexts.quantity}</h2>
							<h2 className={s.cart_header_column}>{staticTexts.price}</h2>
							<h2 className={s.cart_header_column}>{staticTexts.total}</h2>
						</div>
					) : null
				}
				<div className={s.cart_items}>
					{
						Object.keys(shop.checkout.items).map((item) => {
							const productListItem = productList.products[item];
							const productItemPrice = productList.availability[item].price;

							if (productListItem === undefined) return null;

							return (
								<div className={s.cart_item}>
									<span className={s.cart_item_product}>
										<Link className={s.cart_item_product_title} to={`/shop/${productListItem.URI}`}>
											<span>{popup ? `${shop.checkout.items[item].quantity}x ` : ''}{productListItem.name}</span>
											{ !popup ? <span className={s.cart_item_product_title_weight}>{productListItem.weight}</span> : null }
										</Link>
										<a className={s.cart_item_product_remove} onClick={adjustItemHandler} data-id={item} href="#removeItem">[{staticTexts.remove}]</a>
									</span>
									{
										!popup ? (
											<div className={s.cart_item_adjust}>
												<div className={s.cart_item_adjust_quantity}>
													<a className={s.cart_item_adjust_decrease} onClick={adjustItemHandler} data-id={item} href="#decreaseItem">-</a>
													<span>{shop.checkout.items[item].quantity}</span>
													<a className={s.cart_item_adjust_increase} onClick={adjustItemHandler} data-id={item} href="#increaseItem">+</a>
												</div>
											</div>
										) : null
									}
									<span className={s.cart_item_price}>{productListItem.price}</span>
									<span className={s.cart_item_subtotal}>{formatPrice((productItemPrice * shop.checkout.items[item].quantity), shop.currencyFormat)}</span>
								</div>
							);
						})
					}
				</div>
				<div className={s.cart_subTotal}>{staticTexts.subtotal}<span className={s.cart_subTotal_price}>{formatPrice(shop.checkout.totals.subTotalPrice, shop.currencyFormat)}</span></div>
				<Button href={popup ? '/bag' : shop.checkout.location} text={staticTexts.checkOut} />
				{
					!popup ? <p className={s.cart_info}>{staticTexts.shippingAndTaxesWillBeCalculatedAtCheckout}</p> : null
				}
			</div>
		</div>
	);
};

export default Cart;



// WEBPACK FOOTER //
// ./components/Cart/Cart.jsx